import React, { useRef } from 'react';
import './HomePage.css';

const HomePage = () => {
  const clickSoundRef = useRef(null);

  const playClickSound = () => {
    if (clickSoundRef.current) {
      clickSoundRef.current.currentTime = 0;
      clickSoundRef.current.play();
    }
  };

  return (
    <div className="home-container">

      {/* Sound */}
      <audio
        ref={clickSoundRef}
        src="/mixkit-modern-technology-select-3124.wav"
        preload="auto"
      />

      {/* Hero Section */}
      <div className="hero-banner">
        <img
          src="/scaffolding-west-yorkshire.jpg"
          alt="B&W Scaffolding West Yorkshire"
          className="hero-logo"
        />
        <div className="hero-text">
          <h1>B&W Scaffolding</h1>
          <p>Raising standards one level at a time</p>
        </div>
      </div>

      {/* Services Section */}
      <div className="services-section">
        <h2>Our Services</h2>
        <div className="services-cards">
          <div className="service-card">
            <h3>Residential Scaffolding</h3>
            <p>Safe and reliable scaffolding for homes.</p>
          </div>
          <div className="service-card">
            <h3>Commercial Scaffolding</h3>
            <p>Efficient scaffolding for businesses and construction sites.</p>
          </div>
          <div className="service-card">
            <h3>Industrial Scaffolding</h3>
            <p>Large-scale scaffolding solutions for industrial projects.</p>
          </div>
        </div>
      </div>

      {/* Contact CTA */}
      <div className="contact-section">
        <h2>Contact Us Today</h2>
        <p>Reach out to discuss your scaffolding needs.</p>

        <a
          href="tel:07801753368"
          className="cta-button"
          onClick={playClickSound}
        >
          Call Us
        </a>

        <a
          href="mailto:b.wscaffoldingco@gmail.com"
          className="cta-button"
          onClick={playClickSound}
        >
          Email Us
        </a>
      </div>

    </div>
  );
};

export default HomePage;